"use client";

import { Button, Stack, Typography } from "@mui/material";
import { FontAwesomeIcon, LinkBehaviour } from "@osn/react-components";
import { useRegisterHref } from "./use-register-href";

/** The sign-in card's one call to create an account, at the foot of the card below the sign-in options. */
export default function RegisterPrompt() {
  const registerHref = useRegisterHref();

  return (
    <Stack
      component="section"
      aria-labelledby="register-prompt-title"
      data-cy="register-prompt"
      sx={{
        alignItems: "center",
        bgcolor: "warning.light",
        borderTop: 3,
        borderColor: "golden.main",
        gap: 1,
        px: 3,
        py: 2,
        textAlign: "center",
      }}
    >
      <Stack sx={{ gap: 0.25 }}>
        <Typography id="register-prompt-title" variant="subsectionTitle" component="h2">
          New here?
        </Typography>
        <Typography variant="bodyCompactMuted">Create a free account before registering a player.</Typography>
      </Stack>
      <Button
        endIcon={<FontAwesomeIcon icon="fa-arrow-right" style={{ fontSize: 11 }} />}
        fullWidth
        href={registerHref}
        LinkComponent={LinkBehaviour}
        size="large"
        variant="outlined"
      >
        Create an account
      </Button>
    </Stack>
  );
}
